module.exports = __webpack_public_path__ + "static/media/camcorder.a6d712d8.svg";